import { getAuth } from 'firebase/auth';

export async function fetchDownloads() {
  const auth = getAuth();
  const user = auth.currentUser;

  if (!user) {
    throw new Error('Not authenticated');
  }

  const token = await user.getIdToken();
  const res = await fetch('/api/downloads', {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
  if (!res.ok) {
    throw new Error('Failed to fetch downloads');
  }

  return res.json();
}

export async function handleGetDownload(key: string) {
  if (!key || key === '') return;

  // Normalise: strip any leading 'api/downloads/' prefix that may have
  // been stored in the data, so the key is always just the item ID.
  const normalisedKey = key.replace(/^api\/downloads\//, '');

  const auth = getAuth();
  const user = auth.currentUser;
  if (!user) throw new Error('Not authenticated');
  const token = await user.getIdToken();

  try {
    const res = await fetch(
      `/api/downloads/${encodeURIComponent(normalisedKey)}`,
      {
        method: 'GET',
        headers: { Authorization: `Bearer ${token}` },
        credentials: 'same-origin'
      }
    );

    if (!res.ok) {
      const text = await res.text().catch(() => '(empty)');
      console.error('Download error:', res.status, text);
      return;
    }

    const { url } = await res.json();
    const a = document.createElement('a');
    a.href = url;
    a.target = '_blank';
    a.rel = 'noreferrer noopener';
    document.body.appendChild(a);
    a.click();
    a.remove();

    // const blob = await res.blob();
    // const contentDisposition = res.headers.get('content-disposition') || '';
    // const fileNameMatch = /filename="?([^"]+)"?/.exec(contentDisposition);
    // const filename = fileNameMatch ? fileNameMatch[1] : normalisedKey;

    // const url = window.URL.createObjectURL(blob);
    // const a = document.createElement('a');
    // a.href = url;
    // a.download = filename;
    // document.body.appendChild(a);
    // a.click();
    // a.remove();
    window.URL.revokeObjectURL(url);
  } catch (e) {
    console.error('Could not make download get request.', e);
  }
}
